export const MODULE_TYPE = Object.freeze({
  FIELD: "FIELD",
});

export const ONBOARDING_STEPS_YEARLY = Object.freeze({
  INFO: "INFO",
  FIELD_SELECT: "FIELD_SELECT",
  MODULE_SELECT: "MODULE_SELECT",
  ADD_YEARLY_DATA: "ADD_YEARLY_DATA",
  SUCCESS: "SUCCESS",
});

export const ONBOARDING_PERCENTAGES_YEARLY = {
  [ONBOARDING_STEPS_YEARLY.INFO]: undefined, // this is on purpose
  [ONBOARDING_STEPS_YEARLY.MODULE_SELECT]: 33,
  [ONBOARDING_STEPS_YEARLY.FIELD_SELECT]: 66,
  [ONBOARDING_STEPS_YEARLY.ADD_YEARLY_DATA]: 100,
};

export const ONBOARDING_STEPS_BASELINE = Object.freeze({
  INFO: "INFO",
  FIELD_SELECT: "FIELD_SELECT",
  MODULE_SELECT: "MODULE_SELECT",
  BASELINE_REVIEW: "BASELINE_REVIEW",
  SUCCESS: "SUCCESS",
});

export const ONBOARDING_PERCENTAGES_BASELINE = {
  [ONBOARDING_STEPS_BASELINE.INFO]: undefined, // this is on purpose
  [ONBOARDING_STEPS_BASELINE.MODULE_SELECT]: 33,
  [ONBOARDING_STEPS_BASELINE.FIELD_SELECT]: 66,
  [ONBOARDING_STEPS_BASELINE.BASELINE_REVIEW]: 100,
};

export const ONBOARDING_STEPS_FIELD = Object.freeze({
  INFO: "INFO",
  FIELD_SELECT: "FIELD_SELECT",
  MODULE_SELECT: "MODULE_SELECT",
  ADD_BAU: "ADD_BAU",
  SUCCESS: "SUCCESS",
});

export const ONBOARDING_PERCENTAGES_FIELD = {
  [ONBOARDING_STEPS_FIELD.INFO]: undefined, // this is on purpose
  [ONBOARDING_STEPS_FIELD.MODULE_SELECT]: 33,
  [ONBOARDING_STEPS_FIELD.FIELD_SELECT]: 66,
  [ONBOARDING_STEPS_FIELD.ADD_BAU]: 100,
};

export const ONBOARDING_STEPS_MODULE = Object.freeze({
  FIELD_SELECT: "FIELD_SELECT",
  MODULE_SELECT: "MODULE_SELECT",
  SUCCESS: "SUCCESS",
});

export const EFFORT_SCORE_FEEDBACK_TYPES = Object.freeze({
  ONBOARDING_PAYOUT_PREDICTION: "ONBOARDING_PAYOUT_PREDICTION_EFFORT_SCORE",
  MRV_PAYOUT_PREDICTION: "MRV_PAYOUT_PREDICTION_EFFORT_SCORE",
  YEARLY_DATA_CONFIRMATION: "YEARLY_DATA_CONFIRMATION_EFFORT_SCORE",
  VERIFICATION: "VERIFICATION_EFFORT_SCORE",
});

export const EFFORT_SCORE_FEEDBACK_DISMISSALS = Object.freeze({
  ONBOARDING_PAYOUT_PREDICTION: "ONBOARDING_PAYOUT_PREDICTION_EFFORT_SCORE_DISMISSALS",
  MRV_PAYOUT_PREDICTION: "MRV_PAYOUT_PREDICTION_EFFORT_SCORE_DISMISSALS",
  YEARLY_DATA_CONFIRMATION: "YEARLY_DATA_CONFIRMATION_EFFORT_SCORE_DISMISSALS",
  VERIFICATION: "VERIFICATION_EFFORT_SCORE_DISMISSALS",
});

export const FOOTPRINTING_ONBOARDING = Object.freeze({
  LOCALSTORAGE_KEY: "hasHiddenFootprintingOnboardingBanner",
  THIRTY_DAYS_MS: 30 * 24 * 60 * 60 * 1000,
});
